import { render, staticRenderFns } from "./Sector.vue?vue&type=template&id=2e878de8&scoped=true&"
import script from "./Sector.vue?vue&type=script&lang=js&"
export * from "./Sector.vue?vue&type=script&lang=js&"
import style0 from "./Sector.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Sector.vue?vue&type=style&index=1&id=2e878de8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e878de8",
  null
  
)

export default component.exports